<template>
  <div class="login-wrap">
    <div class="login-form">
      <h2>{{ title }}</h2>
      <el-form ref="loginForm" :model="loginForm" :rules="rules" class="form-wrap">
        <div>
          <el-form-item prop="accountBean.username">
            <el-input prefix-icon="el-icon-user" placeholder="账号" v-model="loginForm.accountBean.username"></el-input>
          </el-form-item>
          <el-form-item prop="accountBean.password">
            <el-input prefix-icon="el-icon-lock" placeholder="密码" v-model="loginForm.accountBean.password" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loginSystem">登 录</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
let patrnNumber = /^.{1,20}$/; // 账号，密码20位之内
import { setToken } from "@/libs/auth.js";
import { title } from "@/config";

export default {
  name: "",
  data() {
    return {
      title,
      loginForm: {
        accountBean: {
          username: "",
          password: ""
        }
      },
      rules: {
        "accountBean.username": [
          { required: true, message: "账号不能为空", trigger: "blur" }
        ],
        "accountBean.password": [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ]
      },
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  mounted() { },
  methods: {
    loginSystem() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch("Login", this.loginForm).then(() => {
            this.$router.push({ path: this.redirect || "/" }).catch(() => { });
          }).catch(() => { });
        } else {
          return false;
        }
      })
    },
  },
};
</script>

<style lang="less">
.login-wrap {
  width: 100%;
  height: 100vh;
  background: rgba(15, 133, 255, 0.6);
  position: relative;
  .login-form {
    width: 560px;
    height: auto;
    background: #161135;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -160px;
    margin-left: -280px;
    h2 {
      text-align: center;
      color: #fff;
      font-size: 26px;
      letter-spacing: 1px;
      margin: 16px auto;
    }
    .form-wrap {
      width: 80%;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 12px 0;
      text-align: center;
      .el-form-item {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .el-input__inner {
        background-color: transparent !important;
        color: #fff !important;
      }
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>